import { h, Component, Fragment } from "preact";
import AwrabetClock from '../../../awrabet/desktop-components/site/clock.jsx';

export default class Clock extends AwrabetClock {

    render() {
        return <div class="inline-block page-clock">
            <i class="fa fa-clock" />
            <span class="inline-block ml-1">{this.currentHour()}</span>
        </div>;
    }
}